import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const requiredFirebaseConfigKeys = [
  "REACT_APP_FIREBASE_API_KEY",
  "REACT_APP_FIREBASE_AUTH_DOMAIN",
  "REACT_APP_FIREBASE_PROJECT_ID",
  "REACT_APP_FIREBASE_APP_ID"
];

const missingFirebaseConfigKeys = requiredFirebaseConfigKeys.filter((key) => {
  const value = process.env[key];
  return !value || !String(value).trim();
});

const hasRequiredFirebaseConfig = missingFirebaseConfigKeys.length === 0;

const firebaseApp = hasRequiredFirebaseConfig ? initializeApp(firebaseConfig) : null;
const db = firebaseApp ? getFirestore(firebaseApp) : null;
const functionsClient = firebaseApp
  ? getFunctions(firebaseApp, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || "asia-south1")
  : null;

let analyticsClient = null;
let analyticsReadyPromise = Promise.resolve(null);
const isAnalyticsEnabled = process.env.REACT_APP_ENABLE_ANALYTICS !== "false";

if (firebaseApp && typeof window !== "undefined" && isAnalyticsEnabled) {
  analyticsReadyPromise = isAnalyticsSupported()
    .then((supported) => {
      if (!supported) {
        return null;
      }

      analyticsClient = getAnalytics(firebaseApp);
      return analyticsClient;
    })
    .catch(() => null);
}

export {
  analyticsClient,
  analyticsReadyPromise,
  db,
  functionsClient,
  hasRequiredFirebaseConfig,
  missingFirebaseConfigKeys
};
